import React from "react";
import { connect } from "react-redux";
import { hideAlertInfo } from "../../store/Alert/actions";

import outside from "../../utilities/outside";
import { Spinner as SpinnerBS } from "react-bootstrap";

const AlertInfo = ({ text, loader, responses, show, ms, hideAlertInfo }) => {
  if (show) {
    if (!loader) setTimeout(() => hideAlertInfo(), ms);

    if (responses && responses[0]) responses.map((m) => console.log(m));

    return (
      <>
        {outside(
          <>
            <div
              className="Alert AlertInfo"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 20,
              }}
            >
              {loader && (
                <SpinnerBS
                  animation="border"
                  role="status"
                  variant="light-md"
                  size="md"
                />
              )}
              {text}
            </div>
          </>
        )}
      </>
    );
  } else {
    return <></>;
  }
};

const stateToProps = (state) => ({
  show: state.alert.info.show,
  text: state.alert.info.text,
  loader: state.alert.info.loader,
  responses: state.alert.info.responses,
  ms: state.alert.info.ms,
});

const actionsToProps = {
  hideAlertInfo,
};

export default connect(stateToProps, actionsToProps)(AlertInfo);
